import { Button, Heading, Text } from '@noorden-insurtech/alba-design-system';

interface ExpiredLinkMessageProps {
  onRequestNewLink: () => void;
  loading?: boolean;
}

export function ExpiredLinkMessage({
  onRequestNewLink,
  loading = false,
}: ExpiredLinkMessageProps) {
  return (
    <div className='flex flex-col gap-6 items-center justify-center w-full'>
      <div className='flex flex-col gap-2 items-start justify-center w-full text-[#2E3A70]'>
        <Heading size='lg' className='text-[#2E3A70] font-bold'>
          Link de acesso expirado.
        </Heading>
        <Text size='sm' className='text-[#5C5C7A]'>
          Por segurança, o link só é válido por tempo limitado.
        </Text>
      </div>

      <Button
        onClick={onRequestNewLink}
        variant='primary'
        size='large'
        disabled={loading}
        className='w-full h-[48px] bg-[#2E3A70] text-white text-[20px] font-bold rounded-[16px]'
      >
        {loading ? 'Solicitando...' : 'Solicitar novo link'}
      </Button>
    </div>
  );
}
